var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.888 18.432a2.636 2.636 0 0 0 0-3.744L4.64 1.216C3.616.16 1.92.16.864 1.184S-.192 3.904.832 4.96l13.28 13.472v-3.744L.768 28c-1.024 1.056-1.024 2.752 0 3.776 1.056 1.056 2.752 1.056 3.776 0l13.344-13.344zm0-3.744v3.744L31.168 4.96c1.024-1.056 1.024-2.752-.032-3.776S28.384.16 27.36 1.216L14.112 14.688c-1.024 1.056-1.024 2.72 0 3.744l13.344 13.344c1.024 1.056 2.72 1.056 3.776 0 1.024-1.024 1.024-2.72 0-3.776L17.888 14.688z"
  })));
};
export default SvgCross;